import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import TypeGoods from './typeGoods';
import ReceiverInfo from './receiverInfo';
import GoodsInfo from './goodsInfo';
import PayInfo from './payInfo';
import CalcPrice from './calcPrice';

import { toggleSidebar } from '../../../store/actions/layout';

const Order = () => {
   const dispatch = useDispatch();

   const { section } = useSelector((state) => state.order);
   const { isSidebarOpened } = useSelector((state) => state.layout);

   useEffect(() => {
      window.scrollTo(0, 0);
      dispatch({ type: 'RESET_ORDER' });
   }, []);

   return (
      <main className='progress' onClick={() => isSidebarOpened && dispatch(toggleSidebar())}>
         <h1 className='progress__title'>ثبت سفارش</h1>
         <ul className='progresstabs'>
            <li className='progresstab next'>
               <img className='progresstab-img' src='/img/home-svgrepo-com.png' alt='tan' />
               <h2 className='progresstab-title'>انتخاب مبدا و نوع ارسال</h2>
            </li>
            <li className={section > 1 ? 'progresstab next' : 'progresstab'} id='level-2'>
               <img className='progresstab-img' src='/img/identification.png' alt='' />
               <h2 className='progresstab-title'>مشخصات گیرنده</h2>
            </li>
            <li className={section > 2 ? 'progresstab next' : 'progresstab'} id='level-3'>
               <img className='progresstab-img' src='/img/box1-svgrepo-com.png' alt='tab' />
               <h2 className='progresstab-title'>مشخصات کالا</h2>
            </li>
            <li className={section > 3 ? 'progresstab next' : 'progresstab'} id='level-4'>
               <img className='progresstab-img' src='/img/money-cash-svgrepo-com.png' alt='tab' />
               <h2 className='progresstab-title'>اطلاعات پرداخت</h2>
            </li>
            <li className={section > 4 ? 'progresstab next' : 'progresstab'} id='level-5'>
               <img className='progresstab-img' src='/img/check1-svgrepo-com.png' alt='tab' />
               <h2 className='progresstab-title'>تایید نهایی</h2>
            </li>
         </ul>
         <div className='progress__body'>
            <TypeGoods />
            <ReceiverInfo />
            <GoodsInfo />
            <PayInfo />
            <CalcPrice />
         </div>
      </main>
   );
};

export default Order;
